import type { Prototype } from "../prototype-types";

export const lanLamPrototypes: Prototype[] = [
  {
    id: "ll-hpl-mvp",
    name: "HPL MVP",
    path: "/ll/hpl-mvp",
    description:
      "MVP of the High Potential Leads Customers page — leads overview, top opportunities, and lead segments in the Brand Portal.",
    owner: "Lan Lam",
    createdAt: "2026-09-01",
    lastUpdated: "2026-09-01",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ll-hpl-mvp.png",
    creationTool: "claude-code",
  },
  {
    id: "bfp-states",
    name: "BFP States",
    path: "/ll/bfp-states",
    description:
      "Rebuild of /brand-portal/my-shop/promotions with a clearer status system across shopwide, market, collection, and promo-code promos. Uses entity brand b_or0vvyanpz (My Spa Life).",
    owner: "Lan Lam",
    createdAt: "2026-04-27",
    lastUpdated: "2026-04-28",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/be3a77a2f6637e1e4b58ecd57d674c2977a9efe3a1da85f01e5b933f9f0b6fc7.png",
    creationTool: "cursor",
  },
  {
    id: "brand-promotions-performance",
    name: "Brand Promotion Performance",
    path: "/brand-promotions-performance",
    description:
      "Brand portal Promotions hub + exploratory performance metrics. Brand profile from entity DB token b_or0vvyanpz (My Spa Life). Table rows and KPIs are illustrative.",
    owner: "Lan Lam",
    createdAt: "2026-04-15",
    lastUpdated: "2026-04-28",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9dde05ed9f2fbccbd66c3b1be2ebdba4780b7d7a7ffcf60d2173c388613f9657.png",
    creationTool: "cursor",
  },
  {
    id: "brand-funded-promo-modal",
    name: "Brand-funded promo modal",
    path: "/brand-funded-promo-modal",
    description:
      "Ceremonia retailer brand shop (entity b_4240zqg5kc + sample products): banner/avatar from CDN, 6-col grid, promo modal. Re-import via entity-db upsert after faire auth for live API data.",
    owner: "Lan Lam",
    createdAt: "2026-04-13",
    lastUpdated: "2026-04-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e07cd7728beb5cc986ca31e82925138f17dec423c8509a2cf8013494b8a2b2bb.png",
    figmaLink:
      "https://www.figma.com/design/Yf1jASbNvNuOUN9ltXT4wY/Promotions?node-id=8527-6416",
    creationTool: "cursor",
  },
  {
    id: "brand-updates-phase-2",
    name: "Brand updates (phase 2)",
    path: "",
    description:
      "Prototype of my-brands/updates (faire.com): Brand Insights layout with product tiles from entity DB, scoped to retailer r_83brjumc. Run entity-db upsert on that retailer to sync name from API.",
    owner: "Lan Lam",
    createdAt: "2026-04-06",
    lastUpdated: "2026-04-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/899d1abefd66c0fcf28af7e215c8efb6b167b13f8df28cd2661bed50b5e51181.png",
    figmaLink:
      "https://www.figma.com/design/xjNYvSYkECxTODrgFWfVYm/Brand-updates-for-RelGro?node-id=17735-12139",
    creationTool: "cursor",
  },
  {
    id: "brand-launch-tile",
    name: "Brand Launch Tile",
    path: "",
    externalUrl: "https://tempo-recap-62667853.figma.site",
    description: "Exploration of a brand launch tile for Brand Updates.",
    owner: "Lan Lam",
    createdAt: "2026-04-08",
    lastUpdated: "2026-04-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/12935e54a56a7c4496c701028cbb2c1c9c00488aa6ec7c3822fa800e5a181434.png",
  },
  {
    id: "customer-detail-activity-log",
    name: "Customer Detail Activity Log",
    path: "/ll/customer-detail-activity-log",
    description: "Copy improvements to the customer activity log",
    owner: "Lan Lam",
    createdAt: "2026-04-02",
    lastUpdated: "2026-04-02",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/89b79f84eebf589807bd904843d3f882c06468636ae41b043a8382b4631fa701.png",
    creationTool: "cursor",
  },
  {
    id: "brand-products",
    name: "Brand Products",
    path: "/ll/brand-products",
    description:
      "Rebuild and redesign exploration for the Brand Portal Products page.",
    owner: "Lan Lam",
    createdAt: "2026-03-16",
    lastUpdated: "2026-03-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/3bcdb8529cb694433268590d7d5f4c0ca77dc3a66030eb56935080a00f22d70c.png",
    creationTool: "cursor",
  },
  {
    id: "brand-marketing",
    name: "Brand Marketing",
    path: "/ll/brand-marketing",
    description:
      "Rebuild and redesign exploration for the Brand Portal Marketing page.",
    owner: "Lan Lam",
    createdAt: "2026-03-13",
    lastUpdated: "2026-03-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2b3222ed790dead77026592d2f202b0f7d10f36ecba81b426d201338ce1430ce.png",
    creationTool: "cursor",
  },
  {
    id: "brand-add-product",
    name: "Brand Add Product",
    path: "/ll/brand-add-product",
    description:
      "Product creation flow for brands to add new products to their catalog.",
    owner: "Lan Lam",
    createdAt: "2026-03-16",
    lastUpdated: "2026-03-23",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d377385a37c6f6c13a993b2dab988ff67c9aacd4f623b2b060d8d2fd8e20181c.png",
    hidden: true,
    creationTool: "cursor",
  },
  {
    id: "brand-launch-highlight",
    name: "Brand Launch Highlight",
    path: "/ll/brand-launch-highlight",
    description:
      "Composer tool for brands to create and share product launch updates with retailers.",
    owner: "Lan Lam",
    createdAt: "2026-03-16",
    lastUpdated: "2026-03-23",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d7a00a2bf17e6e61a27e9c5368c6a4335cab7523176b4514b75a32b9a684abd7.png",
    hidden: true,
    creationTool: "cursor",
  },
  {
    id: "brand-funded-promotions-retailer-and-segment",
    name: "Brand-funded Promotions (retailer and segment)",
    path: "",
    externalUrl: "https://paint-wheel-23603536.figma.site",
    description:
      "Exploring a low lift update to allow brand's to target retailer and segment promotions",
    owner: "Lan Lam",
    createdAt: "2026-02-27",
    lastUpdated: "2026-03-04",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9bac37844cde0986f321a427a54cf02af23435b6d29d5a6462240f6b47398085.png",
    creationTool: "figma-make",
  },
  {
    id: "messenger-prioritization-inbox-bulk-automated",
    name: "Messenger Prioritization (inbox, bulk, automated)",
    path: "",
    externalUrl: "https://savor-booth-37807889.figma.site",
    description:
      "Exploring multiple concepts for how Messenger could have  prioritization, bulk messaging, and automated messages.",
    owner: "Lan Lam",
    createdAt: "2026-02-27",
    lastUpdated: "2026-02-27",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1ba80faaf8e7df21b90d11574c401ff77672687870b6491cdb3413209a8dc77e.png",
    creationTool: "figma-make",
  },
  {
    id: "ll-bfp-modal",
    name: "BFP modal",
    path: "/ll/bfp-modal",
    description:
      "The &quot;see details&quot; modal about the promotions being offered",
    project: "BFP modal",
    owner: "Lan Lam",
    createdAt: "2026-05-18",
    lastUpdated: "2026-05-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.faire.com/fastly/31473f148a6de73d0f4efcb4c72201102e4f1198387909f5507325d10950324e.png",
    creationTool: "claude-code",
  },
  {
    id: "ll-promotion-modal",
    name: "Promotion modal",
    path: "/ll/promotion-modal",
    description:
      "Design concepts for the promo modal retailers see on brand page",
    project: "Brand Page Promo Modal",
    owner: "Lan Lam",
    createdAt: "2026-05-21",
    lastUpdated: "2026-05-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.faire.com/fastly/4b9fd05be808a22960c1c49cde8f9aa9e5de6ea1f1f9ee6ef70cc772fbbcc756.png",
    creationTool: "claude-code",
  },
  {
    id: "ll-high-potential-leads-h-2",
    name: "High Potential Leads H2",
    path: "/ll/high-potential-leads-h-2",
    description: "",
    owner: "Lan Lam",
    createdAt: "2026-08-12",
    lastUpdated: "2026-08-12",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/95f6c3f06dd9d4716920df091744fc786560b1aee0bff8aa5c5f3d8f4df09203.png",
    creationTool: "claude-code",
  },
  {
    id: "ll-leads-overview-and-performance",
    name: "Leads overview and performance",
    path: "/ll/leads-overview-and-performance",
    description: "Interactive leads overview and performance module for user interviews",
    owner: "Lan Lam",
    createdAt: "2026-09-11",
    lastUpdated: "2026-09-11",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
      thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/414e4c2a1ac823b7d5c4b01ed86c26d1938294cd2252f5accd515c7147e66253.png"
},
  {
    id: "ll-hpl-with-table",
    name: "HPL with table",
    path: "/ll/hpl-with-table",
    description: "HPL surface with a table layout for the oppty list",
    project: "High Potential Leads Beta",
    owner: "Lan Lam",
    createdAt: "2026-10-08",
    lastUpdated: "2026-10-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
      thumbnail: "/images/thumbnails/ll-hpl-with-table.png"
}
];
